import { ELanguageCode } from "enum/ELanguageCode";
import { CreateProductFormValues } from "./createProductValidationSchema";
import { Product, ProductInfo } from "types/models";

export const mapProductToForm = (
  data: any,
): Product => {
  const arabic = data?.translations?.ar ?? data?.translations?.filter((t: any) => t.languageCode == ELanguageCode.AR)[0];
  const english = data.translations.en ?? data?.translations?.filter((t: any) => t.languageCode == ELanguageCode.EN)[0];
  const manufacturISO = data.countryOfManufactureISO ?? data.countryOfManufacture.iso;
  const registrationISO = data.countryOfRegistrationISO ?? data.countryOfRegistration.iso;

  return {
    translations: {
      ar: {
        name: arabic.name,
        description: arabic.description,
        languageCode: ELanguageCode.AR
      },
      en: {
        name: english.name,
        description: english.description,
        languageCode: ELanguageCode.EN
      }
    },
    weight: data.weight,
    estimatedWeight: data.estimatedWeight,
    drainedWeight: data.drainedWeight,
    weightUnit: data.weightUnit,
    countryOfManufactureISO: manufacturISO ?? undefined,
    countryOfRegistrationISO: registrationISO ?? undefined,
    barcode: data.barcode,
    price: data.price,
    contents: data.contents ?? undefined,
    usages: data.usages ?? undefined,
    ingredients: data.ingredients ?? undefined,
    media: [],
    suggestionId: data.suggestion.id,
  };
};


export const mapProductInfoToForm = (
  data: any,
): ProductInfo => {

  const arabic = data?.translations?.ar ?? data?.translations?.filter((t: any) => t.languageCode == ELanguageCode.AR)[0];
  const english = data.translations.en ?? data?.translations?.filter((t: any) => t.languageCode == ELanguageCode.EN)[0];
  const manufacturISO = data?.countryOfManufactureISO ?? data?.countryOfManufacture?.iso;
  const registrationISO = data?.countryOfRegistrationISO ?? data?.countryOfRegistration?.iso;

  return {
    translations: {
      ar: {
        name: arabic.name,
        description: arabic.description,
        languageCode: ELanguageCode.AR
      },
      en: {
        name: english.name,
        description: english.description,
        languageCode: ELanguageCode.EN
      }
    },
    weight: data.weight,
    estimatedWeight: data.estimatedWeight,
    drainedWeight: data.drainedWeight,
    weightUnit: data.weightUnit,
    countryOfManufactureISO: manufacturISO ?? undefined,
    countryOfRegistrationISO: registrationISO,
    barcode: data.barcode,
    price: data.price,
  };
};
